import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-select-current-source-modal',
    templateUrl: './select-current-source-modal.component.html',
    styleUrls: ['./select-current-source-modal.component.scss'],
    standalone: false
})
export class SelectCurrentSourceModalComponent {
  @Output() optionSelected = new EventEmitter<number>();
  @Input() selectedOption: number;

  selectOption(option) {
    this.optionSelected.emit(option);
  }

}
